import React from "react";
import { FormLabel } from "react-bootstrap";

function CustomLabel({ children }) {
  return <FormLabel>{children}</FormLabel>;
}

export default CustomLabel;
